import { render, staticRenderFns } from "./CHomeOpen.vue?vue&type=template&id=5ffee568&"
import script from "./CHomeOpen.vue?vue&type=script&lang=js&"
export * from "./CHomeOpen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports